import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@els/els-react--text-input';

function SearchInput({ value, onChange }) {
  const inputRef = useRef(null);
  const isInputEmpty = !value;

  return (
    <TextInput
      inputRef={inputRef}
      className="query-builder-search-section__search-input"
      data-e2e="querybuilder-searchsection-searchinput"
      {...(isInputEmpty
        ? {}
        : {
            iconRight: {
              id: 'query-builder-search-section-search-input',
              sprite: 'Close',
              children: 'Clear search fields and forms input',
              a11y: { name: 'Clear search fields and forms input' },
            },
          })}
      iconRightCallback={
        isInputEmpty
          ? undefined
          : () => {
              onChange('');
              setTimeout(() => {
                inputRef.current?.focus();
              }, 0);
            }
      }
      label="Search fields and forms"
      shouldHideLabel
      value={value}
      onChange={(e) => onChange(e.target?.value)}
    />
  );
}

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SearchInput;
